import {combineEpics} from 'redux-observable'
import {
    logInRequestEpic,
    logOutEpic,
    setGlobalUserData,
    getPersonalInfoEpic,
} from './auth'
import {
    shopsRequestSuccessEpic,
    shopsClearDataEpic,
    startInitiallyLoadingShopsEpic,
    shopsRequestStartEpic,
    shopByIdRequestStartEpic,
    reloadShopRequestStartEpic,
    // changeNatsSubscriptionEpic,
    shopByIdRequestSuccessEpic,
    loadShopAdministratorEpic,
} from './shops'
import {
    botPollStatusEpic,
    botsClearDataEpic,
    botsLoadEpic,
    botsRequestStartEpic,
    botUpdateStatisticEpic,
    whatsappGetQRCodeEpic,
    whatsappLogoutRequestStartEpic,
} from './dashboard'
import {
    stepMovedEpic,
    updateFlowConfigEpic,
} from './steps'
import {
    loadBillingConfigEpic,
} from './billing'

import {
    addingNewContactRequestEpics,
    addingNewContactToggleModalEpics,
    importNewContactsRequestEpics,
} from './chats'


export default combineEpics(
    logInRequestEpic,
    logOutEpic,
    setGlobalUserData,
    getPersonalInfoEpic,

    startInitiallyLoadingShopsEpic,
    shopsRequestStartEpic,
    shopsRequestSuccessEpic,
    shopByIdRequestStartEpic,
    reloadShopRequestStartEpic,
    // changeNatsSubscriptionEpic,
    shopByIdRequestSuccessEpic,
    shopsClearDataEpic,
    updateFlowConfigEpic,
    loadShopAdministratorEpic,

    botsLoadEpic,
    botsRequestStartEpic,
    botsClearDataEpic,
    botUpdateStatisticEpic,
    botPollStatusEpic,
    whatsappGetQRCodeEpic,
    whatsappLogoutRequestStartEpic,

    stepMovedEpic,

    loadBillingConfigEpic,

    addingNewContactRequestEpics,
    addingNewContactToggleModalEpics,
    importNewContactsRequestEpics,
)
